// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1KfhT","error":"Textarea_error__2b9k7","readonly":"Textarea_readonly__3-0dn","disabled":"Textarea_disabled__38kSg"};